export const DEFAULT_NOT_MATCH_VIN_DOWNLOAD_FILTER = Object.freeze({
  minYear: 2020,
  requireKnownWmi: true,
  excludeInvalidWmi: true,
  filterInvalidVinMasks: true,
})

function normalizedBaseURL(baseURL) {
  return String(baseURL || '').replace(/\/+$/, '')
}

export function isValidNotMatchVinDownloadFilter(
  value,
  currentYear = new Date().getFullYear(),
) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false

  const maxYear = currentYear + 1
  const validYear = Number.isInteger(value.minYear)
    && (value.minYear === 0 || (value.minYear >= 1980 && value.minYear <= maxYear))

  return validYear
    && typeof value.requireKnownWmi === 'boolean'
    && typeof value.excludeInvalidWmi === 'boolean'
    && (value.filterInvalidVinMasks === undefined
      || typeof value.filterInvalidVinMasks === 'boolean')
}

export function normalizeNotMatchVinDownloadFilter(
  value,
  currentYear = new Date().getFullYear(),
) {
  const source = isValidNotMatchVinDownloadFilter(value, currentYear)
    ? value
    : DEFAULT_NOT_MATCH_VIN_DOWNLOAD_FILTER

  return {
    minYear: source.minYear,
    requireKnownWmi: source.requireKnownWmi,
    excludeInvalidWmi: source.excludeInvalidWmi,
    filterInvalidVinMasks: typeof source.filterInvalidVinMasks === 'boolean'
      ? source.filterInvalidVinMasks
      : true,
  }
}

export function buildNotMatchVinYearOptions(currentYear = new Date().getFullYear()) {
  const options = [{ label: '不限', value: 0 }]
  for (let year = currentYear + 1; year >= 1980; year -= 1) {
    options.push({ label: `${year}年及以后`, value: year })
  }
  return options
}

export function buildNotMatchVinFilterGetRequest(baseURL) {
  return {
    url: `${normalizedBaseURL(baseURL)}/v1/diag/notMatchVinDownloadFilter`,
  }
}

export function buildNotMatchVinFilterSaveRequest(
  baseURL,
  value,
  currentYear = new Date().getFullYear(),
) {
  if (!isValidNotMatchVinDownloadFilter(value, currentYear)) {
    throw new TypeError('Invalid unmatched VIN download filter configuration')
  }

  return {
    url: `${normalizedBaseURL(baseURL)}/v1/diag/notMatchVinDownloadFilter`,
    data: {
      minYear: value.minYear,
      requireKnownWmi: value.requireKnownWmi,
      excludeInvalidWmi: value.excludeInvalidWmi,
      filterInvalidVinMasks: typeof value.filterInvalidVinMasks === 'boolean'
        ? value.filterInvalidVinMasks
        : true,
    },
    options: { params: { copy: '' } },
  }
}

export function buildNotMatchVinDownloadRequest(baseURL) {
  return {
    url: `${normalizedBaseURL(baseURL)}/v1/diag/downloadNotMatchVinDeliv`,
    options: { responseType: 'blob' },
  }
}
